export default __webpack_public_path__ + "img/2cf24b1652d3955f7f15aabefef30a14.png";